export const NODE_TYPE_ORDER = [
  'agent',
  'input',
  'output',
  'tool',
  'logic',
  'governance',
  'data',
];

/** MCP server categories expanded by default in the sidebar and popovers. */
export const DEFAULT_EXPANDED_MCP_SERVERS = ['Web Search'];

export const isPickerHiddenNode = (node: {
  picker_hidden?: boolean;
  show?: boolean;
}) => node.picker_hidden === true || node.show === false;

export const NODE_TYPE_LABELS: Record<string, string> = {
  agent: 'Agents',
  input: 'Inputs',
  output: 'Outputs',
  tool: 'Tools',
  logic: 'Logic',
  governance: 'Governance',
  data: 'Data',
};
